module.exports = __webpack_public_path__ + "img/appointments_white.dbb88354.svg";